
async function extractFlashNoticesFromTurboResponse(e) {
  const { fetchResponse } = e.detail;

  if(!fetchResponse.isHTML) return;

  const response = fetchResponse.response.clone();

  const plainHTML = await response.text();

  if(!plainHTML.includes("flash_messages")) return;

  const htmlDoc = new DOMParser().parseFromString(plainHTML, "text/html");
  const flashMessagesElement = htmlDoc.querySelector("[target='flash_messages']");

  if(!flashMessagesElement) return;

  document.body.insertAdjacentElement("beforeend", flashMessagesElement);
}

document.addEventListener("turbo:before-fetch-response", extractFlashNoticesFromTurboResponse);
